/**
 * Active entry: functional sign-up page.
 * Legacy class: ./SignUp.js
 */
import SignUpPage from "./SignUpPage";

export default SignUpPage;
